import { createFileRoute } from "@tanstack/react-router";
import { Box } from "@salestrak/ui";
import { PageHeader } from "#app/components/page-header";
import { IssuesTable } from "#app/components/issues/issues-table";
import { FilterPanel } from "#app/components/filters/filter-panel";
import { issueFilterConfig } from "#app/lib/filters/configs/issue-filter-config";
import {
  IssueFilterProvider,
  useIssueFilters,
} from "#app/lib/filters/issue-filter-context";
import { useWorkspaceData } from "#app/lib/data/workspace-data-provider";

/**
 * `/member/$memberId` — a single member's assigned projects across every
 * workflow, rendered by the shared {@link IssuesTable} scoped to the member.
 */
function MemberDetail() {
  const { memberId } = Route.useParams();
  const { userMap } = useWorkspaceData();
  const member = userMap.get(memberId);
  return (
    <IssueFilterProvider>
      <MemberInner
        memberId={memberId}
        title={member?.name ?? member?.email ?? "Member"}
      />
    </IssueFilterProvider>
  );
}

function MemberInner({ memberId, title }: { memberId: string; title: string }) {
  const { filters, filterPanelOpen, closeFilterPanel } = useIssueFilters();
  return (
    <Box direction="column" fill="flex">
      <PageHeader title={title} />
      <IssuesTable scope={{ kind: "member", memberId }} />
      <FilterPanel
        open={filterPanelOpen}
        onOpenChange={closeFilterPanel}
        config={issueFilterConfig}
        filters={filters}
      />
    </Box>
  );
}

export const Route = createFileRoute("/(app)/$workspace/member/$memberId/")({
  component: MemberDetail,
});
